import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { boosterData } from "../../../services/BoosterServices"; // Example service function
import CreateOrUpdateBooster from "../CreateBooster/CreateBooster";
import { useCreatorBoostersContext } from "../../../context/Creator/CreatorBoostersProvider";

const UpdateBooster: React.FC = () => {
  const { boosterId } = useParams<{ boosterId: string }>();
  const [booster, setBooster] = useState<boosterData | undefined>();
  const { boostersState } = useCreatorBoostersContext();

  useEffect(() => {
    const id = boosterId;

    if (id) {
      (async () => {
        try {
          const boosterToUpdate = boostersState.data.find((e) => e.id === id);
          if (!boosterToUpdate) {
            console.log("you can't modify this booster");
            return;
          }

          setBooster(boosterToUpdate);
        } catch (error) {
          console.error("Failed to fetch booster:", error);
        }
      })();
    }
  }, [boosterId, boostersState.data]); // Added boosters as dependency to re-run when the boosters context changes

  if (boosterId && !booster) {
    return <div>Loading...</div>;
  }

  return <CreateOrUpdateBooster booster={booster} />;
};

export default UpdateBooster;
